/**
 * Buckets — the budgeting dimension.
 *
 * There are four, and they are not the same kind of thing. Three of them
 * (Needs, Wants, Savings) divide up income and carry percentages that sum to
 * 100. The fourth, Income, is what they divide — it has no percentage, and
 * asking "what share of income is Income?" is a category error.
 *
 * That is why `SPENDING_BUCKETS` and `BUCKETS` are separate: anything that
 * plans, allocates or compares against a target works on the three, and only
 * category classification works on all four.
 *
 * INVARIANT (AGENTS.md §3.5): a bucket is resolved as
 *   split.bucketOverride ?? category.bucket
 * and never read from the entry. One supermarket trip genuinely spans Needs
 * (the week's groceries) and Wants (the €90 bottle of wine).
 */
export const SPENDING_BUCKETS = ['NEEDS', 'WANTS', 'SAVINGS'];
export const BUCKETS = ['NEEDS', 'WANTS', 'SAVINGS', 'INCOME'];
export function isBucket(value) {
    return typeof value === 'string' && BUCKETS.includes(value);
}
export function isSpendingBucket(value) {
    return typeof value === 'string' && SPENDING_BUCKETS.includes(value);
}
export function resolveBucket(split, category) {
    return split.bucketOverride ?? category.bucket;
}
/** An empty record over the three spending buckets — the start of any rollup. */
export function emptySpendingMap(initial) {
    return { NEEDS: initial(), WANTS: initial(), SAVINGS: initial() };
}
export const BUCKET_LABELS = {
    NEEDS: 'Needs',
    WANTS: 'Wants',
    SAVINGS: 'Savings & Investments',
    INCOME: 'Income',
};
/** Short forms, for places where the full label will not fit. */
export const BUCKET_SHORT_LABELS = {
    NEEDS: 'Needs',
    WANTS: 'Wants',
    SAVINGS: 'Savings',
    INCOME: 'Income',
};
//# sourceMappingURL=bucket.js.map